import Swal from "sweetalert2";

export function init(tag: any): void {
  tag.saveAsPDF = () => {
    window.print();
  };
  tag.displayHelp = () => {
    Swal.fire({
      title: document.getElementById('ahv-help-display-title').innerHTML,
      text: document.getElementById('ahv-help-display-text').innerHTML,
      type: 'info',
      showConfirmButton: true,
      confirmButtonColor: '#5a059b',
      allowEscapeKey: true,
      allowOutsideClick: true,
      animation: false
    });
  };
}



/** WEBPACK FOOTER **
 ** ./src/components/housingValueSearchBar/HousingValueSearchBarController.ts
 **/